import { TherapistAction } from "src/redux/actions/constant";

const intialState: object = {
    response: null,
    loading: false,
    isError: false,
};

export const therapistDialogAssignTaskReducer = (state = intialState, action: any) => {
    switch (action.type) {
        case TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_SUCCESS: {
            return {
                ...state,
                response: action.payload,
                loading: false,
                isError: false,
            };
        }
        case TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_FAILURE: {
            return {
                ...state,
                response: action.payload,
                loading: false,
                isError: true,
            };
        }
        case TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }
        case TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_RESET: {
            return {
                ...state,
                response: null,
                loading: true,
            };
        }
        default:
            return state;
    }
};
